import { format } from 'date-fns';

/**
 * Class responsible for logging to the console.
 */
export class Logger {
  name: string;
  prodMode: boolean = false;

  /**
   * @param name     The name to be printed as a prefix for all messages logged by this new instance.
   * @param prodMode Enable/Disable the production mode. When set to true only `WARN` and `ERROR`
   *                 messages are to be logged. Default is false.
   */
  constructor(name: string, prodMode?: boolean) {
    this.name = name;
    if (prodMode) {
      this.prodMode = prodMode;
    }
  }

  public debug(message?: string, ...optionalParams: any[]) {
    if (this.prodMode) {
      return;
    }
    optionalParams = ['font-weight: normal;', ...optionalParams];
    console.debug.apply(console, [this.getMessage(message), ...optionalParams]);
  }

  public info(message?: string, ...optionalParams: any[]) {
    optionalParams = ['font-weight: normal;', ...optionalParams];

    console.info.apply(console, [this.getMessage(message), ...optionalParams]);
  }

  public warn(message?: string, ...optionalParams: any[]) {
    optionalParams = ['color: orange; font-weight: normal;', ...optionalParams];

    console.warn.apply(console, [this.getMessage(message), ...optionalParams]);
  }

  public error(message?: string, ...optionalParams: any[]) {
    optionalParams = ['color: red; font-weight: normal;', ...optionalParams];
    if (optionalParams) {
      console.error.apply(console, [this.getMessage(message), ...optionalParams]);
    } else {
      console.error.apply(console, [this.getMessage(message)]);
    }
  }

  private getMessage(message?: string): any {
    const time = format(new Date(), 'HH:mm:ss.SSS');
    return `%c${time} - ${this.name} -- ${message}`;
  }
}
